(function() {
  var app;

  app = angular.module("App", ["ngResource"]);

  app.constant('ApplicationName', 'AFGRI eAccounts');

  app.constant('SupportNumber', '0110632025');

  app.constant('RebrandFeatureEnum', 92);

  app.controller("LoginController", [
    "$scope", "$resource", "$window", "$location", "$http", "LocationFactory", "CICADA_CONFIG", "ApplicationName", "SupportNumber", "RebrandFeatureEnum", function($scope, $resource, $window, $location, $http, LocationFactory, CICADA_CONFIG, ApplicationName, SupportNumber, RebrandFeatureEnum) {
      var errorHandler, getIsRebrandActive, getQueryParams;
      $scope.forgotPasswordMessage = false;
      $scope.login_status = "";
      $scope.url = CICADA_CONFIG.legacyApi;
      $scope.ApplicationName = ApplicationName;
      $scope.SupportNumber = SupportNumber;
      $scope.SiteKey = CICADA_CONFIG.GoogleRecaptchaSiteKey;
      $scope.SMSGateway = CICADA_CONFIG.SMSGateway;
      $scope.apiStatus = "";
      $scope.securityTooStrong = false;
      $scope.rebrand = false;
      $scope.hidePassword = true;
      $scope.loginEmail = false;
      $scope.loginEmailEmpty = false;
      $scope.loginPassword = false;
      $scope.idFieldEmpty = true;
      $scope.emailValid = false;
      $scope.emailFieldEmpty = true;
      $scope.resetStep = 0;
      $scope.reCaptchaSuccess = false;
      getQueryParams = function(params, url) {
        var href, queryString, reg;
        href = url;
        reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
        queryString = reg.exec(href);
        if (queryString) {
          return queryString[1];
        } else {
          return null;
        }
      };
      $scope.client_id = getQueryParams('client_id', $window.location.search);
      getIsRebrandActive = function() {
        return $http.get($scope.url + '/api/Config/FeatureToggle/IsActive/' + RebrandFeatureEnum).then(function(response) {
          var data;
          data = response.data;
          return $scope.rebrand = data;
        });
      };
      getIsRebrandActive();
      if ($location.$$absUrl.search('unavailable') > 0) {
        $scope.apiStatus = "unavailable";
      }
      errorHandler = function(error) {
        console.log("error", error);
        if (error.status === 503 || error.status === -1) {
          $scope.login_status = "unavailable";
        } else {
          $scope.login_status = "unauthorized";
        }
        $scope.$broadcast("login_failed");
        return error;
      };
      $scope.revealPassword = function(val) {
        $scope.x = $window.document.getElementById(val);
        if ($scope.x.type === "password") {
          $scope.hidePassword = false;
          return $scope.x.type = "text";
        } else {
          $scope.hidePassword = true;
          return $scope.x.type = "password";
        }
      };
      $scope.initMaintenanceMode = function() {
        $http.get($scope.url + "/api/Support/MaintenanceMode").then(function(response) {
          return $scope.MaintenanceMode = response.data;
        })["catch"](function(error) {
          return $scope.apiStatus = "unavailable";
        });
        $http.get($scope.url + "/api/Support/CustomLoginMessage").then(function(response) {
          var data;
          data = response.data;
          $scope.CustomMsgState = data.IsCustomLoginMessageAcive;
          if ($scope.CustomMsgState) {
            $scope.DisplayDocument = data.HasDocument;
            $scope.CustomMsg = data.CustomLoginMessage;
            $scope.CustomMsgType = data.TypeOfCustomLoginMessage;
            if ($scope.DisplayDocument) {
              return $scope.CustomDocumentText = data.DocumentText;
            } else {
              return $scope.CustomDocumentText = "";
            }
          }
        })["catch"](function(error) {
          return $scope.apiStatus = "unavailable";
        });
        $scope.GetDocument = function(type) {
          return $window.open("api/documents/" + type + "/latest", "_blank");
        };
        return LocationFactory.getCurrentLocation().then((function(position) {
          var coords;
          coords = position.coords;
          $scope.longitude = coords.longitude;
          $scope.latitude = coords.latitude;
          $scope.locationAccuracy = coords.accuracy;
          return console.log("Longitude: " + coords.longitude + ", Latitude: " + coords.latitude + ", Accuracy: " + coords.accuracy);
        }));
      };
      $scope.login = function() {
        var user;
        $scope.forgotPassword = false;
        $scope.login_status = "busy";
        user = {
          username: $scope.username,
          password: $scope.password,
          longitude: $scope.longitude,
          latitude: $scope.latitude,
          locationAccuracy: $scope.locationAccuracy,
          ApplicationClientId: $scope.client_id
        };
        return $http.post($scope.url + '/api/session', user).then(function(response) {
          var data;
          data = response.data;
          sessionStorage.setItem("X-XSRF-TOKEN", data.XSRF);
          sessionStorage.setItem("Cicada-Cookie", data.Cookie);
          sessionStorage.setItem("JWTBearer", data.JWTBearer);
          sessionStorage.setItem("AccessToken", data.AccessToken);
          sessionStorage.setItem("RefreshToken", data.RefreshToken);
          if ($scope.client_id && $scope.client_id.length > 0 && data.RedirectUrl.length > 0) {
            return $window.location.href = data.RedirectUrl + "?id_token=" + data.JWTBearer + "&access_token=" + data.AccessToken + "&refresh_token=" + data.RefreshToken + "&token_type=bearer";
          } else {
            return $window.location.href = "/index";
          }
        })["catch"](function(er) {
          $scope.login_status = "";
          console.log("Login failed with error:", er);
          return errorHandler(er);
        });
      };
      $scope.register = function() {
        $scope.forgotPassword = false;
        return $window.location.href = "/register";
      };
      $scope.cancelReset = function() {
        $scope.showErrors = false;
        $scope.resetPass = false;
        $scope.resetStep = 0;
        $scope.resetPassId = "";
        $scope.resetPassEmail = "";
        return $scope.resetPassOtp = "";
      };
      $scope.startReset = function() {
        if ($scope.forgotPasswordMessage === true) {
          return $scope.forgotPassword = true;
        } else {
          $scope.otpAttempts = 0;
          $scope.maxAttempts = false;
          $scope.resetOtpInvalid = false;
          $scope.resetEmail = '';
          $scope.resetIdNumber = '';
          $scope.resetOtp = '';
          $scope.showErrors = false;
          $scope.resetPass = true;
          $scope.resetStep = 1;
          $scope.resetPassId = "";
          $scope.resetPassEmail = "";
          $scope.resetPassOtp = "";
          $scope.fromReset = false;
          $scope.forgotPassword = false;
          $scope.validOtpBusy = false;
          $scope.resetsExceeded = false;
          return $scope.reCaptchaSuccess = false;
        }
      };
      $scope.$watch("username", function(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          $scope.loginEmailEmpty = false;
        } else {
          $scope.loginEmailEmpty = true;
        }
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newValue)) {
          return $scope.loginEmail = true;
        } else {
          return $scope.loginEmail = false;
        }
      });
      $scope.$watch("password", function(newValue, oldValue) {
        return $scope.loginPassword = newValue && newValue.length > 0;
      });
      $scope.$watch("resetPassEmail", function(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          $scope.emailFieldEmpty = false;
        } else {
          $scope.emailFieldEmpty = true;
        }
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newValue)) {
          return $scope.emailValid = true;
        } else {
          return $scope.emailValid = false;
        }
      });
      $scope.$watch("resetPassId", function(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          $scope.idFieldEmpty = false;
        } else {
          $scope.idFieldEmpty = true;
        }
        if (/^((([0-9]{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[13456789]|1[012])(0[1-9]|[12][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)([0-9]{4})( |-)([0-9]{3})|([0-9]{7}))$/.test(newValue)) {
          return $scope.idValid = true;
        } else {
          return $scope.idValid = false;
        }
      });
      $window.submitReset = function(_token) {
        $scope.validOtpBusy = true;
        $scope.resetStep = 2;
        return $http.post($scope.url + "/api/forgotPassword/captcha", null, {
          headers: {
            "reCaptchaToken": _token
          }
        }).then(function(res) {
          if (res.data === "Success") {
            $scope.reCaptchaSuccess = true;
            $scope.validOtpBusy = false;
            return $scope.resetPassword();
          } else {
            $scope.reCaptchaSuccess = false;
            $scope.validOtpBusy = false;
            return grecaptcha.reset();
          }
        })["catch"](function(er) {
          return console.log("reCaptcha failed with error:", er);
        });
      };
      $scope.resetPassword = function() {
        if ($scope.emailValid && $scope.idValid) {
          $scope.showErrors = false;
          return $http.post($scope.url + "/api/forgotPassword", {
            Username: $scope.resetPassEmail,
            IdNumber: $scope.resetPassId
          }).then(function(res) {
            return console.log('ForgotPassword API call successful');
          })["catch"](function(er) {
            return console.log('ForgotPassword API call failed');
          });
        } else {
          grecaptcha.reset();
          return $scope.showErrors = true;
        }
      };
      return $scope.validateOtp = function() {
        var otpContract;
        $scope.validOtpBusy = true;
        otpContract = {
          Username: $scope.resetPassEmail,
          IdNumber: $scope.resetPassId,
          Otp: $scope.resetPassOtp
        };
        if ($scope.otpAttempts < 3) {
          return $http.post($scope.url + "/api/forgotPassword/Otp", otpContract, {
            headers: {
              "Cicada-Otp": otpContract.Otp,
              "Username": otpContract.Username
            }
          }).then(function(res) {
            console.log('ForgotPasswordOtp API call successful', res);
            if (res.data === 'ResetsExceeded') {
              $scope.resetsExceeded = true;
            } else if (res.data === 'TechnicalError') {
              $scope.technicalError = true;
            } else {
              $scope.resetStep = 0;
              $scope.resetPass = false;
              $scope.fromReset = true;
            }
            return $scope.validOtpBusy = false;
          })["catch"](function(er) {
            console.log('ForgotPasswordOtp API call failed with error: ', er);
            $scope.resetOtpInvalid = true;
            $scope.validOtpBusy = false;
            $scope.otpAttempts = $scope.otpAttempts + 1;
            if ($scope.otpAttempts === 3) {
              $scope.maxAttempts = true;
            }
            if (er === 'ResetsExceeded') {
              return $scope.resetsExceeded = true;
            }
          });
        }
      };
    }
  ]);

  app = angular.module('App');

  app.directive('ccSpinner', function() {
    return function(scope, elem, attr) {
      var opts, spinner;
      opts = {
        lines: 13,
        length: 0,
        width: 16,
        radius: 29,
        corners: 1,
        rotate: 0,
        direction: 1,
        color: '#bce08a',
        speed: 1,
        trail: 60,
        shadow: false,
        hwaccel: true,
        className: 'spinner',
        zIndex: 2e9,
        top: 'auto',
        left: 'auto'
      };
      if (attr.ccSpinnerSize === "small") {
        opts.lines = 7;
        opts.width = 6;
        opts.radius = 6;
        opts.color = '#000';
      }
      if (attr.ccSpinnerSize === "medium") {
        opts.lines = 8;
        opts.width = 9;
        opts.radius = 9;
        opts.color = '#000';
      }
      if (attr.ccSpinnerSize === 'container') {
        opts.className = 'spinner-container';
      }
      if (attr.ccSpinnerSize === 'row') {
        opts.className = 'spinner-row';
      }
      spinner = new Spinner(opts);
      return scope.$watch(attr.ccSpinner, function(newValue, oldValue) {
        if (newValue) {
          spinner.spin();
          return elem[0].appendChild(spinner.el);
        } else {
          return spinner.stop();
        }
      });
    };
  });

  app = angular.module("App");

  app.factory("LocationFactory", [
    "$q", "$window", function($q, $window) {
      var getCurrentLocation, getLocationOptions;
      getLocationOptions = {
        timeout: 10000
      };
      getCurrentLocation = function() {
        var deferred;
        deferred = $q.defer();
        if (!$window.navigator.geolocation) {
          deferred.reject('Geolocation is not available');
        } else {
          $window.navigator.geolocation.getCurrentPosition(function(position) {
            return deferred.resolve(position);
          }, function(error) {
            return deferred.reject(error);
          }, getLocationOptions);
        }
        return deferred.promise;
      };
      return {
        getCurrentLocation: getCurrentLocation
      };
    }
  ]);

}).call(this);

//# sourceMappingURL=login-bundled.js.map
